module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-fade",
    class: _vm.className,
    style: (_vm.loaded ? {
      backgroundImage: ("url('" + _vm.src + "')"),
      opacity: 1,
    } : {}),
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11f581c1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Avatar.vue
// module id = 452
// module chunks = 2